
<template>
  <v-card
    :flat="flatCard"
    :class="classStyle"
    :minWidth="minW"
  >
    <v-toolbar
      v-if="displayToolbar"
      :dense="isDense"
      :color="colorToolBar"
      :flat="flatToolBar"
      :style="leftBorder ? 'border-left: 7px solid #26384B; border-radius: 4px': ''"
    >
      <slot name="icon" />
      <v-spacer v-if="!leftBorder" />
      <div
        v-if="leftIcon"
        class="d-flex justify-center align-center"
        style="border: 1px solid #26384B; border-radius: 4px; width: 26px; height: 26px; margin-right: 5px"
      >
        <v-icon
          dense
          color="#26384B"
        >
          bar_chart
        </v-icon>
      </div>
      <v-toolbar-title class="d-flex">
        <span
          :class="!leftBorder ? 'white--text': ''"
          style="font-size: 16px; font-weight: 400"
        >
          {{ title }}
        </span>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <slot name="items" />
      </v-toolbar-items>
    </v-toolbar>
    <v-sheet>
      <slot name="content" />
    </v-sheet>
    <v-card-actions>
      <v-spacer />
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
    name: 'CustomCard',
    props: {
        title: {
            type: String,
            default: null,
        },
        minW: {
            type: String,
            default: null,
        },
        flatToolBar: {
            type: Boolean,
            default: false,
        },
        flatCard: {
            type: Boolean,
            default: false,
        },
        colorToolBar: {
            type: String,
            default: null,
        },
        classStyle: {
            type: String,
            default: null,
        },
        isDense: {
            type: Boolean,
            default: true,
        },
        leftBorder: {
            type: Boolean,
            default: false,
        },
        leftIcon: {
            type: Boolean,
            default: false,
        },
        displayToolbar: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
